export default "__VITE_ASSET__0llkJOdV__"